import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "@activehub/common-components-spa/dist/index.min.css";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createHashRouter, RouterProvider } from "react-router-dom";

import { ErrorBoundary, I18nContextProvider } from "@activehub/common-components-spa";
import { AccessAndAdminApp } from "./BaseApp";

// Data router required for useBlocker support in React Router v6.4+
const router = createHashRouter(
  [{ path: "*", element: <I18nContextProvider><AccessAndAdminApp /></I18nContextProvider> }],
  { future: { v7_startTransition: true } }
);

const root = createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary errorPage="PageLoadFails">
    <RouterProvider router={router} />
  </ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
